module.exports = __webpack_public_path__ + "static/img/Kobe Logo Blue.d9e463d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Kobe Logo Blue.png
// module id = 122
// module chunks = 0